import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
// services
import { MessageService } from "../../../../../../services/message.service";
import { MasterService } from "../../../../../../services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as languageLibrary from '../../../../../../services/language'
import { StoreService } from "src/app/services/store.service";
import { PAYMENT_CYCLES } from '../../../../../../constants/payments'
import { formatDecimal } from '../../../../../../utils/format'
import { Sale } from "src/app/models/sale.model";
import { Payment } from "src/app/models/payment.model";
import { InsurancePolicy } from "src/app/models/insurance-policy.model";
import { PersonalAutoInsurance } from "src/app/models/personal-auto-insurance.model";


@Component({
    selector: "outside-insurance",
    templateUrl: "./outside-insurance.component.html",
    styleUrls: ["./outside-insurance.component.scss"],
    standalone: false
})
export class OutsideInsuranceComponent implements OnInit, OnChanges {

    @Input() saleId: number;
    
    @Input() sale: Sale;
    
    @Input() outsideInsurancePolicyInfo: InsurancePolicy;
    
    @Output() emitterInformation$: EventEmitter<Object> = new EventEmitter()
    
protected id: number | null = null
    
    protected status: string | null = null;
    
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    protected personalPolicies: PersonalAutoInsurance[] = []
    
    protected words = languageLibrary.language

    protected loading: boolean = false

    public information = new FormGroup({
        id: new FormControl<number>(null),
        contactId: new FormControl<number>(null, [Validators.required]),
        saleId: new FormControl<number>(null, [Validators.required]),
        cpi: new FormControl<boolean>(false, [Validators.required]),
        status: new FormControl<string>('active', [Validators.required]),
        policyNumber: new FormControl<string | null>(null, [Validators.required]),
        effectiveDate: new FormControl<string>(new Date().toISOString().substring(0, 10), [Validators.required]),
        endDate: new FormControl<Date>(null, []),
        companyName: new FormControl<string | null>(null, [])
    })
    
    // todo: listen to output of navbar
    public listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            default:
                break;
        }
    }

    get policyInEffect (): boolean {
        const id = this.information.get('id').value
        if (!id || isNaN(id) || (id <= 0)) {
            return false
        }

        return true
    }

    constructor(private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private store: StoreService, private location: Location) {}

    ngOnInit() {
        this.fetchPersonalAutoInsurance()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sale) {
            if (!this.sale) {
                return
            }

            this.information.get('saleId').setValue(this.saleId)
        }

        if (changes.outsideInsurancePolicyInfo) {
            if (!changes.outsideInsurancePolicyInfo.currentValue) {
                return
            }

            this.setInformation(this.outsideInsurancePolicyInfo)
        }
    }

    /** */
    private reset() {
        this.id = null
        this.status = null
        this.information.reset()
        this.information.get('saleId').setValue(this.saleId)
        this.information.get('status').setValue('active')
        this.information.get('cpi').setValue(false)
        this.information.get('policyNumber').setValue(null)
        this.information.get('effectiveDate').setValue(new Date().toISOString().substring(0, 10))
        this.information.get('endDate').setValue(null)
    }

    protected setInformation(outsidePolicy: InsurancePolicy) {
        this.id = outsidePolicy['id']
        this.status = outsidePolicy['status']
        this.information.setValue({
            id: outsidePolicy.id,
            cpi: outsidePolicy.cpi,
            saleId: outsidePolicy.saleId,
            status: outsidePolicy.status,
            contactId: outsidePolicy.contactId,
            policyNumber: outsidePolicy.policyNumber,
            effectiveDate: outsidePolicy.effectiveDate instanceof Date ? outsidePolicy.effectiveDate.toISOString().substring(0, 10) : outsidePolicy.effectiveDate,
            endDate: outsidePolicy.endDate,
            companyName: outsidePolicy.contact.companyName
        })
    }
      
    protected fetchPersonalAutoInsurance() {
        if (!this.sale || !this.sale.contactId) {
            return
        }

        this.reset()
        this.loading = true
        this.master.get(`contacts/${this.sale.contactId}/personalAutoInsurance`, res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }
        
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }
        
            if (res.data.contactPersonalAutoInsurance.length == 0) {
                return
            }
        
            this.personalPolicies = res.data.contactPersonalAutoInsurance
        })
    }

    protected save() {
        if (!this.information.valid) {
            return
        }

        this.information.updateValueAndValidity({ onlySelf: true })
        if (this.id <= 0) {
            this.create()
            return
        }

        this.modify()
    }

    protected modify() {
        if (!this.saleId || !this.id || (this.saleId <= 0) || (this.id <= 0)) {
            return
        }

        const payload = JSON.parse(JSON.stringify(this.information.value))
        delete(payload.id)
        delete(payload.companyName)

        this.master.put(`sales/${this.saleId}/insurance/${this.id}`, { information: payload }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.emitterInformation$.emit({ message: 'getAutoInsurance' })

        })
    }

    protected create() {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        const payload = JSON.parse(JSON.stringify(this.information.value))
        delete(payload.id)
        delete(payload.companyName)

        if (payload.status.toLocaleLowerCase() !== 'inactive') {
            this.information.get('status').setValue('active', {emitEvent: false})
            payload.status = 'active'
        }

        this.master.post(`sales/${this.saleId}/insurance/`, { information: payload }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.emitterInformation$.emit({ message: 'getAutoInsurance' })
            this.location.replaceState(`sales/${this.saleId}/insurance/${this.id}`);
        })
    }
    
    protected deactivate() {
        if (!this.saleId || !this.id || (this.saleId <= 0) || (this.id <= 0)) {
            return
        }

        this.master.patch(`sales/${this.saleId}/insurance/${this.id}/deactivate`, { saleId: this.saleId }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.reset()

            document.getElementById("btn-close-modal-cancel-insurance").click();
            this.emitterInformation$.emit({ message: 'getAutoInsurance' })
        })
    }

    /**
     * 
     */
    protected providerChosen = (contactId: number): void => {
        if (!contactId || (contactId <= 0)) {
            this.information.get('contactId').setValue(0)
        }

        this.information.get('contactId').setValue(contactId)
    }
}
